






































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Api} from "@/core/services/MedicaPro/Api";

@Component({
    components: {}
})
export default class Dashboard extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public userName = '';
    public countUsers = 0;
    public countClients = 0;
    public countTherapists = 0;

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.userName = this.currentUser?.name ?? '';
        this.isReady = true;
        this.loadData();
    }

    private loadData() {
        Api.users().get().count(value => this.countUsers = value);
        Api.clients().get().count(value => this.countClients = value);
        Api.therapists().get().count(value => this.countTherapists = value);
    }

    public onUsersBoxClicked() {
        this.$router.push({
            name: 'Users',
        }).catch(() => {});
    }

    public onClientsBoxClicked() {
        this.$router.push({
            name: 'Clients',
        }).catch(() => {});
    }

    public onTherapistsBoxClicked() {
        this.$router.push({
            name: 'Therapists',
        }).catch(() => {});
    }

}
